import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import { SENTRY_DSN, SENTRY_ENVIRONMENT } from 'commons/constants/env'
import App from './App'
import 'commons/mocks/msw'

Sentry.init({
  dsn: SENTRY_DSN,
  environment: SENTRY_ENVIRONMENT,
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
})

ReactDOM.render(<App />, document.getElementById('root'))
